import { devLog, devError } from '../utils/devLogger';
import React from 'react';
import { Navbar, Nav, Container, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { useAuth } from '../auth/AuthContext';
import { getDefaultRouteForRole } from '../services/roleManagementService';

const ExternalNavbar = () => {
  const navigate = useNavigate();
  const { isExternalFacilitator, isExternalViewer } = useAuth();

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      devError('Failed to log out', error);
    }
  };

  // Get default route based on role
  const getDefaultRoute = () => {
    if (isExternalFacilitator && isExternalFacilitator()) {
      return getDefaultRouteForRole('external_facilitator_limited');
    }
    if (isExternalViewer && isExternalViewer()) {
      return getDefaultRouteForRole('external_viewer_reporting');
    }
    return '/external';
  };

  return (
    <Navbar variant="dark" expand="lg" className="navbar-gradient">
      <Container>
        <Navbar.Brand
          onClick={() => navigate(getDefaultRoute())}
          style={{ cursor: 'pointer' }}
          className="d-flex align-items-center"
        >
          <div className="d-flex align-items-center gap-2">
            <img
              src="/Access70Logo.png"
              alt="Access70"
              height="40"
              style={{ maxHeight: '40px', width: 'auto' }}
            />
            <img
              src="/NPI_Logo.png"
              alt="NPI Governance Solutions"
              height="50"
              style={{ maxHeight: '50px', width: 'auto' }}
            />
          </div>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {/* External Facilitator Navigation */}
            {isExternalFacilitator && isExternalFacilitator() && (
              <>
                <Nav.Link onClick={() => navigate('/external-facilitator')}>
                  Dashboard
                </Nav.Link>
              </>
            )}

            {/* External Viewer Navigation */}
            {isExternalViewer && isExternalViewer() && (
              <>
                <Nav.Link onClick={() => navigate('/external-viewer')}>
                  Dashboard
                </Nav.Link>
              </>
            )}

            {/* Generic External Navigation (Fallback) */}
            {(!isExternalFacilitator || !isExternalFacilitator()) &&
             (!isExternalViewer || !isExternalViewer()) && (
              <>
                <Nav.Link onClick={() => navigate('/external')}>Dashboard</Nav.Link>
                <Nav.Link onClick={() => navigate('/reports')}>Reports</Nav.Link>
                <Nav.Link onClick={() => navigate('/resources')}>Resources</Nav.Link>
              </>
            )}

            <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default ExternalNavbar;
